import { Box } from "@mui/material";
import React from "react";
import NavigationSection from "./NavigationSection";
import DataMigrationSection from "./DataMigration";
import SecureDataTransferSection from "./SecureDataSection";
import FeaturesSection from "./FeaturesSection";
import HeroSection from "./HeroSection";
import ReliableWebStorageSection from "./ReliableSection";
import CallToActionSection from "./CallToAction";
import FooterSection from "./FooterSection";

const Main = () => {
  return (
    <Box
      sx={{
        bgcolor: "white",
        display: "flex",
        justifyContent: "center",
        width: "100%",
      }}
    >
      <Box
        sx={{
          bgcolor: "white",
          width: "100%",
          maxWidth: 1440,
          position: "relative",
        }}
      >
        <NavigationSection />
        <DataMigrationSection />
        <SecureDataTransferSection />
        <FeaturesSection />
        <HeroSection />
        <ReliableWebStorageSection />
        <CallToActionSection />
        <FooterSection />
      </Box>
    </Box>
  );
};

export default Main;